import React, { useContext, useState } from "react";
import { CommandBarButton, CommandBarButtonMenuItem, depascalize } from "sprint-common-web";

import { FileRecordStatus } from "../../../../../common/types/FileRecordStatus";
import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";
import { UpdateMultipleFileRecordStatusDialogManager } from "./components/UpdateMultipleFileRecordStatusDialogManager";

const availableStatuses = [
    FileRecordStatus.Editing,
    FileRecordStatus.Qc,
    FileRecordStatus.Rejected,
    FileRecordStatus.Destroyed,
    FileRecordStatus.WaitingForClientResponse
];

export const UpdateMultipleFileRecordsStatusButton: React.VFC = () => {
    const { selectedItems } = useContext(FileRecordListingContext);
    const [selectedStatus, setSelectedStatus] = useState<FileRecordStatus>();
    const [statuses] = useState<FileRecordStatus[]>(availableStatuses);

    const statusOptions = getStatusOptions(statuses, setSelectedStatus);

    const isOpen = !!selectedStatus;

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <CommandBarButton
                text="Change status"
                icon="Edit"
                menuItems={statusOptions}
                disabled={selectedItems.length < 1}
            />
            {isOpen && (
                <UpdateMultipleFileRecordStatusDialogManager
                    isOpen={isOpen}
                    onDismiss={() => setSelectedStatus(undefined)}
                    status={selectedStatus}
                />
            )}
        </AuthorizationWrapper>
    );
};

const getStatusOptions = (
    statuses: FileRecordStatus[],
    onClick: (status: FileRecordStatus) => void
): CommandBarButtonMenuItem[] => {
    return statuses.map((status) => ({
        key: status,
        text: depascalize(FileRecordStatus[status]),
        onClick: () => onClick(status)
    }));
};
